<template>
  <div class="hello">
    <h3>Namen Finder</h3>
    <p>
      Wie findet man einen Namen?
    </p>

    <h5>
      Wie heißt du?
    </h5>

    <div class="column" v-if="userNameAvailable && !modUser">
      <div class="columns">
        <div class="column col-8">
          <div class="float-left">
            {{ greeting }}
          </div>

        </div>
        <div class="column col-4">
          <button class="btn btn-link" @click="toggleUserEdit">Wechseln</button>
        </div>
      </div>
    </div>
    <div class="column" v-else>
      <div class="columns">
        <form @submit.prevent class="column col-8">
          <!-- form input control -->
          <div class="input-group">
            <input type="text" class="form-input" :placeholder="greeting" v-model="userName" />
          </div>
        </form>
        <div class="col-4">
          <button class="btn btn-primary input-group-btn" @click="setUserName">Name festlegen</button>
        </div>
      </div>
    </div>

    <div class="divider"></div>
    <div class="onlyUser" v-if="userNameAvailable">
      <h5>
        Bewerte Namen:
      </h5>
      <div class="column">
        <div class="columns">
          <div class="column col-8">
            <div class="float-left">
              Favoriten
            </div>

          </div>
          <div class="column col-4">
            <button
              :class="[userNameAvailable ? '' : 'disabled']"
              class="btn btn-primary"
              @click="move({ name: 'Names', params: {visibility: 'favorite' } })">
                Start
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { db } from '../firebase'
const names = db().ref('names')
import Names from '../models/names'
const namesModel = Names({namesDb: names})
import router from '@/router'
import { userName, empty, User } from '../helper/helper'

export default {
  name: 'hello',
  data() {
    return {
      userName: '',
      user: User(),
      recommendation: '',
      modUser: false,
      recommendClass: '',
      formHintRecommendation: ''
    };
  },
  computed: {
    userNameAvailable: function(){
      return this.user.loggedIn()
    },
    greeting: function() {
      if (this.user.loggedIn()) {
        return this.user.getFormated()
      } else {
        return 'Bitte Benutzername eingeben'
      }
    }
  },
  methods: {
    setUserName: function () {
      if (this.userName) {
        User().set(this.userName)
        this.user = User()
        this.toggleUserEdit()
      } else {
        this.greeting = 'Wir brauchen einen Benutzernamen'
      }

    },
    move: function (object) {
      router.push(object)
    },
    toggleUserEdit: function() {
      this.modUser = !this.modUser
    },
    addName: function() {
      namesModel.addName(this.recommendation, this.user.get())
      .then(() => {
        this.formHintRecommendation = `${this.recommendation} hinzugefügt`
        this.recommendation = ''
        this.recommendClass = 'has-success'
        setTimeout(() => {
          this.formHintRecommendation = ''
          this.recommendClass = ''
        }, 2000)
      })
      .catch(() => {
        this.recommendClass = 'has-danger'
        this.formHintRecommendation = `Der Name ${this.recommendation} existiert schon.`
        setTimeout(() => {
          this.formHintRecommendation = ''
          this.recommendClass = ''
        }, 2000)
      })
    },

  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
.columns{
  align-items: center;
  justify-content: center;
}
.recommendationInput{
  height: 40px;
}
</style>



// WEBPACK FOOTER //
// Hello.vue?282798a8